import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Button } from "@/landing-page/components/button"
import WhiteLogo from "@/landing-page/components/icons/white_logo"
import Beans from "@/landing-page/components/icons/beans"
import Amoeba from "@/landing-page/components/icons/amoeba"
import artists from "@/landing-page/images/Carrossel-Selcionados-e-Consagrados.webp"
import { trackEvent } from "@/helpers/ga"

export function Hero() {
  return (
    <section className="bg-green lg:pt-24 pt-20 pb-0 relative z-10 overflow-hidden dark:bg-black">
      <StaticImage
        loading="eager"
        src="../images/bg_1.webp"
        alt="Imagem de fundo"
        width={3840}
        height={4186}
        className="!absolute top-0 left-0 -z-20 block h-full dark:hidden"
      />

      <div className="container flex flex-col items-center">
        <div className="w-full lg:hidden text-white font-bold text-center mb-4">
          Ministério da Cultura e <br />
          Cartão Elo apresentam:
        </div>

        <WhiteLogo aria-label="Logo" className="block mb-8 w-full h-auto lg:max-w-md text-white" />

        <h1 className="font-serif text-sand text-center lg:text-3xl text-2xl mb-3">
          Gravar sua música com um grande artista e direção musical <br />
          de Maria Gadú e Pretinho da Serrinha.
        </h1>

        <p className="text-sand text-center mb-12 lg:text-3xl text-xl lg:max-w-3xl">
          Esse é seu sonho? Então vem viver com a gente!
        </p>

        <div className="bg-green-dark rounded-2xl lg:px-8 px-10 py-10 mb-10 relative dark:bg-green-dark2">
          <Beans aria-label="Feijões" className="absolute lg:-left-10 -left-8 -top-9 w-16 h-auto" />

          <p className="text-xl text-sand text-center font-bold">
            <span className="text-green">10</span> GRANDES ARTISTAS NACIONAIS.
            <br />
            <span className="text-red">10</span> RITMOS REGIONAIS.
            <br />A <span className="text-blue">CHANCE</span> QUE VOCÊ ESPERAVA
            <br /> PARA IMPULSIONAR A SUA CARREIRA.
          </p>

          <Amoeba aria-label="Amoeba" className="absolute -right-4 -bottom-6 w-16 h-auto" />
        </div>

        <p className="text-white text-center text-xl">
          Período de gravação entre dezembro e fevereiro.<br></br>Siga nos acompanhando nas redes sociais!
        </p>

        <h3 className="absolute bottom-10 text-sand lg:text-4xl text-2xl text-center lg:w-3/5 w-full lg:px-4 dark:bg-black dark:bottom-0 dark:lg:py-10 dark:py-4">
          Conectando <b className="text-yellow">artistas</b>, realizando <b className="text-yellow">sonhos</b> e
          valorizando nossa <b className="text-yellow">cultura</b>.
        </h3>
      </div>

      <div
        className="block w-full h-96 lg:h-[22rem] shadow-inset-custom overflow-hidden lg:animate-moveX animate-moveXMobile bg-cover bg-repeat-x dark:shadow-none mt-10"
        style={{ backgroundImage: `url("${artists}")` }}
      ></div>
    </section>
  )
}
